var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90597 1.91782L10.286 0.721151C10.3333 0.714367 10.3815 0.717828 10.4273 0.731301C10.4731 0.744774 10.5156 0.767944 10.5517 0.79924C10.5878 0.830535 10.6167 0.869226 10.6365 0.91269C10.6564 0.956153 10.6666 1.00337 10.6666 1.05115V14.9485C10.6666 14.9962 10.6564 15.0434 10.6366 15.0868C10.6168 15.1302 10.5879 15.1688 10.5519 15.2001C10.5158 15.2314 10.4735 15.2546 10.4278 15.2681C10.382 15.2816 10.3339 15.2852 10.2866 15.2785L1.90531 14.0818C1.74639 14.0592 1.60097 13.98 1.49577 13.8587C1.39057 13.7375 1.33264 13.5823 1.33264 13.4218V2.57782C1.33264 2.41729 1.39057 2.26216 1.49577 2.14091C1.60097 2.01967 1.74705 1.94045 1.90597 1.91782ZM2.66664 3.15648V12.8432L9.33331 13.7958V2.20382L2.66664 3.15648ZM11.3333 12.6665H13.3333V3.33315H11.3333V1.99982H14C14.1768 1.99982 14.3464 2.07006 14.4714 2.19508C14.5964 2.3201 14.6666 2.48967 14.6666 2.66648V13.3332C14.6666 13.51 14.5964 13.6795 14.4714 13.8046C14.3464 13.9296 14.1768 13.9998 14 13.9998H11.3333V12.6665ZM6.79998 7.99982L8.66664 10.6665H7.06664L5.99998 9.14248L4.93331 10.6665H3.33331L5.19998 7.99982L3.33331 5.33315H4.93331L5.99998 6.85715L7.06664 5.33315H8.66664L6.79998 7.99982Z",
    fill: "#393945"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.5296718f.svg";
export { ForwardRef as ReactComponent };